import type { IconProps } from './types';

export const LogoutIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            {...props}
            id="Component_251_2"
            data-name="Component 251 – 2"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <rect id="Rectangle_6643" data-name="Rectangle 6643" width="24" height="24" fill="none" />
            <g id="Group_14372" data-name="Group 14372" transform="translate(2176 -3614)">
                <path
                    id="Path_5508"
                    data-name="Path 5508"
                    d="M19,10H12a3,3,0,0,0-3,3V23a3,3,0,0,0,3,3h7"
                    transform="translate(-2182 3608)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <line
                    id="Line_42"
                    data-name="Line 42"
                    x2="10"
                    transform="translate(-2165 3626)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_5509"
                    data-name="Path 5509"
                    d="M23.465,14.465,27,18l-3.536,3.535"
                    transform="translate(-2182 3608)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </svg>
    );
};
